// extracted by mini-css-extract-plugin
module.exports = {"container":"Subpage-module--container--2r2rc"};